import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { ListItem, ListItemText, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AppContext from "../contexts/AppContext";
import componentStyles from "../assets/styles/components/sidebar_project_list";
import { setProject } from "../actions";

const useStyles = makeStyles(componentStyles);

export const SidebarProjectListItem = (props) => {
  const { projects = [], setAnchorEl } = props;
  const { state, dispatch } = useContext(AppContext);
  const history = useHistory();
  const classes = useStyles();

  const handleClickSetProjectButton = async (project) => {
    await setProject(dispatch, { project: project });
    if (setAnchorEl) setAnchorEl(null);
    history.push("/project/" + project.id + "/issues");
  };

  return (
    <>
      {projects.map((project, index) => {
        return (
          <ListItem
            key={index}
            button
            onClick={(e) => handleClickSetProjectButton(project)}
            className={classes.listItemRoot}
            selected={
              state.current.project && project.id === state.current.project.id
            }
          >
            <ListItemText
              className={classes.listItemText}
              primary={
                <Typography style={{ fontSize: "0.85rem" }}>
                  {project.name}
                </Typography>
              }
            />
          </ListItem>
        );
      })}
    </>
  );
};
